import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface StudentMatchResult {
  code: string;
  first_name: string;
  last_name: string | null;
  nickname: string | null;
  education_level?: string | null;
}

export const useStudentMatchSearch = (search: string) => {
  return useQuery({
    enabled: search.trim().length >= 1,
    queryKey: ['student-match-search', search],
    queryFn: async (): Promise<StudentMatchResult[]> => {
      const s = `%${search.trim()}%`;
      const { data, error } = await (supabase as any)
        .schema("student")
        .from('fishsix_students')
        .select('code,first_name,last_name,nickname')
        .eq('is_active', true)
        .is('deleted_at', null)
        .or(`code.ilike.${s},first_name.ilike.${s},last_name.ilike.${s},nickname.ilike.${s}`)
        .order('code', { ascending: true })
        .limit(20);
      if (error) throw error;
      return (data ?? []) as StudentMatchResult[];
    },
  });
};

export const useStudentByCode = (code: string) => {
  return useQuery({
    enabled: !!code,
    queryKey: ['student-match-by-code', code],
    queryFn: async (): Promise<StudentMatchResult | null> => {
      const { data, error } = await (supabase as any)
        .schema("student")
        .from('fishsix_students')
        .select('code,first_name,last_name,nickname,education_level')
        .eq('code', code)
        .maybeSingle();
      if (error) throw error;
      return (data as StudentMatchResult) ?? null;
    },
  });
};
